import { invoiceService } from '../../services'

// initial state
const state = () => ({
  invoice: null,
  invoiceStatus: {},
})

// actions
const actions = {
  getInvoice({ commit }, invoiceId) {
    invoiceService.getInvoice(invoiceId)
      .then(
        invoice => {
          commit('invoiceSuccess', invoice);
        },
        error => {
          commit('invoiceFailure', error);
        }
      );
  },
  createInvoice({ commit }, taskIds) {
    commit('waitResponse');
    invoiceService.createInvoice(taskIds)
      .then(
        invoice => {
          commit('invoiceCreateSuccess', invoice);
        },
        error => {
          commit('invoiceCreateFailure', error);
        }
      );
  },
}

// mutations
const mutations = {
  waitResponse(state) {
      state.invoiceStatus = { isWaiting: true };
  },
  invoiceCreateSuccess(state, invoice) {
      state.invoice = invoice;
      state.invoiceStatus = {};
  },
  invoiceCreateFailure(state, error) {
      console.log(state, error);
      state.invoiceStatus = {};
  },
  invoiceSuccess(state, invoice) {
      state.invoice = invoice;
      state.invoiceStatus = {};
  },
  invoiceFailure(state, error) {
      console.log(state, error);
      state.invoiceStatus = {};
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
